import Api from "../state/Api";
import { configStore, contractsStore, loginStore } from "../state/CommonState";
import MonApi, { GET_ENQUIRIES_SUMMARY_URI } from '../state/mongo-api';
import Utils from "../util/Utils"

export default class ChartApi {
    static async getByList(url, entityIds) {
        try {
            let headers = Api.H();

            if (!loginStore.isClient()) {
                headers['Current-Entity'] = configStore.chartSelectedEntity;
            }
            headers["Content-Type"] = "application/json"
            if (!Array.isArray(entityIds) || entityIds.length === 0) {
                console.warn("No entity IDs provided for API request.")
                return null
            }
            // console.log("entityIds", entityIds);

            let payload = {
                entityIds: entityIds
            }
            const requestOptions = {
                headers: headers,
                method: "POST",
                credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit', 
                body: JSON.stringify(payload)
            }
            const response = await fetch(url, requestOptions);
            return await response.json();
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }
    
    static async get(url) {
        let h = Api.H()
        if(!loginStore.isClient()){
           h['Current-Entity'] = configStore.chartSelectedEntity
        }
        const requestOptions = {
            headers: h,
           credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
        }

        return await fetch(url, requestOptions).then(res => res.json())
    }

    static async post(url , payload) {
        let h = Api.H()
        if(!loginStore.isClient()){
           h['Current-Entity'] = configStore.chartSelectedEntity
        }
          h["Content-Type"] = "application/json"
        // h.append('entityCustomerCode', id)
        // let payload =  {
        //     entityCustomerCode : id,
        //     category : category  
        //   }
        const requestOptions = {
            headers: h,
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            params : payload.entityCustomerCode,
            method: "POST",
            body : JSON.stringify(payload)
        }

        return await fetch(url, requestOptions).then(res => res.json())
    }

    static async postSendFinSheet(url ,  payload) {
        let h = Api.H1()
        if(!loginStore.isClient()){
           h['Current-Entity'] = configStore.chartSelectedEntity
        }
        h["Content-Type"] = "application/json"
         const requestOptions = {
            headers: h,
            // params : id,
            method: "POST",
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body :  payload
        }

        return await fetch(url, requestOptions).then(res => res.json())
    }
    static async postAvgPayDays(url ,  payload) {
        let h = Api.H1()
        if(!loginStore.isClient()){
           h['Current-Entity'] = configStore.chartSelectedEntity
        }
        h["Content-Type"] = "application/json"
        // h.append('entityCustomerCode', id)
        // let payload =  {
        //     entityCustomerCode : id  
        //   }
        const requestOptions = {
            headers: h,
            // params : id,
            method: "POST",
            credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
            body :  JSON.stringify(payload)
        }

        return await fetch(url, requestOptions).then(res => res.json())
    }

    static async getVisibilityDashData(callback = f=>f , entityCategory) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/getvisibilitydashdata`
        let payload =  {
            entityCategory : entityCategory,
          }
        let ret = await ChartApi.post(url , payload)
        callback(ret)
        return ret
    }

    static async getEnquirySummary(callback = f=>f) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/chart/getenquiriesdata`
        let ret = await ChartApi.get(url)
        callback(ret)
        return ret
    }
    static async getEnquiryCount() {
        let filter = {}
        if (loginStore.isClient()) filter = {'gst': configStore.currentSelectedEntity.gst }
        let ret = await MonApi.apost(GET_ENQUIRIES_SUMMARY_URI, [{
  '$match': filter
}, {
  '$count': 'count'
}])
        console.log('RETURN FROM ENQUIRIES QUERY=', filter, ret)
        if (ret.length > 0) return ret[0].count
        return 0
    }
    static async getEnquiryQuote() {
        let filter = {}
        if (loginStore.isClient()) filter = {'gst': configStore.currentSelectedEntity.gst }
        let ret = await MonApi.apost(GET_ENQUIRIES_SUMMARY_URI, [{
  '$match': filter
}, {
  '$lookup': {
    from: 'Quotes',
    localField: '_id',
    foreignField: '_id',
    as: 'quotes'
  }
}, {
  '$unwind': '$quotes'
}, {
  '$project': {
    _id: 1,
    'gst': 1,
    'quotes.mailedOn': 1,
    'enquiryDate': 1
  }
}])
        return ret
    }
    static async getProductData(callback = f=>f) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/chart/getproductdata`
        let ret = await ChartApi.get(url)
        callback(ret)
        return ret
    }
    static async getFinanceData(callback = f=>f , customerCode, category , setfinDataLoading , openFinance) {
        // let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/financialsnew`
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/financialserp`
        if(customerCode.includes('/')){
            customerCode = customerCode.split("/")[0] 
        }
        setfinDataLoading(true)
         let payload =  {
            entityCustomerCode : customerCode,
            category : category  ,
            getTotalList : openFinance
          }
        let ret = await ChartApi.post(url , payload)
        callback(ret)
        setfinDataLoading(false)
        return ret
    }

     static async getFinanceTableData(query , setResults ) {
        // let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/financialsnew`
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/financeTableData`
         let payload =  query
        let ret = await ChartApi.post(url , payload)
        setResults(ret)
        return ret
    }

    static async getDutiesPayment(payload ,callback = f=>f) {
        // let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/financialsnew`
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/avgDutiesPayment`

        let ret = await ChartApi.postAvgPayDays(url , payload)
        callback(ret)
        return ret
    }

    static async sendCusFinSht(payload , callback = f=>f  ) {
        // let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/financialsnew`
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/sendCusFinanceSheetMail`       
        let ret = await ChartApi.postSendFinSheet(url , payload)
        callback(ret)
        return ret
    }

    static async getAllBookingsForChart(callback = f => f, entityIds , setLoading) {
        
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/bookingcharts`
        setLoading(true)
        let ret = await ChartApi.getByList(url, entityIds)
        setLoading(false)
        callback(ret)
        return ret
    }

    static async getContractsForChart(callback = f => f, entityIds) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/contracts/contractscharts`
        let data = await ChartApi.getByList(url, entityIds)
        if (!contractsStore.navigateFromCharts) contractsStore.list = data
        console.log('*** LOADED NEW CONTRACTS ***')
        callback(data)
        return data
    }
}